<template>
    <div v-if="thanphod" class="edit-thanphod container" id="fontLao">
        <h2>ແກ້ໄຂຂໍ້ມູນ : {{ thanphod.title }}</h2>
        <form @submit.prevent="EditThanphod">
            <div class="field title">
                <label for="title">ຫົວຂໍ້ ບໍລິສັດ: </label>
                <input type="text" name="title" v-model="thanphod.title" id="fontLao">
            </div>
            <div v-for="(ing, index) in thanphod.ingredients" :key="index" class="field">
                <label for="ingredient">ຂໍ້ມູນບໍລິສັດ:</label>
                <input type="text" name="ingredient" v-model="thanphod.ingredients[index]" id="fontLao">
                <i class="material-icons delete" @click="deleteIng(ing)">delete</i>
            </div>
            <div class="field add-ingredient">
                <label for="add-ingredient">ເພີ່ມຂໍ້ມູນ ບໍລິສັດ:</label>
                <input type="text" name="add-ingredient" @keydown.tab.prevent="addIng" v-model="another" id="fontLao">
            </div>
            <div class="field center-align">
                <p v-if="feedback" class="red-text">{{ feedback }}</p>
                <button class="btn pink" id="fontLao">ປ່ຽນແປງຂໍ້ມູນ</button>
            </div>
        </form>
    </div>
</template> 

<script>
import db from '@/firebase/init'
import slugify from 'slugify'
export default {
    name: 'EditThanphod',
    data(){
        return{
            thanphod: null,
            another: null,
            feedback: null
        }
    },
    methods:{
        EditThanphod(){
            if(this.thanphod.title){
                this.feedback = null
                // create a slug
                this.thanphod.slug = slugify(this.thanphod.title, {
                    replacement: '-',
                    remove: /[$*_+~.()'"!\-:@]/g,
                    lower:true
                })
                db.collection('thanphods').doc(this.thanphod.id).add({ 
                    title: this.thanphod.title,
                    ingredients: this.thanphod.ingredients,
                    slug : this.thanphod.slug
                }).then(() => {
                    this.$router.push({ name: 'Index'})
                }).catch(err => {
                    console.log(err)
                })
            }else {
                this.feedback = 'ທ່ານຈະຕ້ອງເພີ່ມຫົວຂໍ້ບໍລິສັດເຂົ້າກ່ອນ'
            }
        },
        addIng(){
            if(this.another){
                this.thanphod.ingredients.push(this.another)
                this.another = null
                this.feedback = null
            } else {
                this.feedback = 'ທ່ານຈະຕ້ອງເພີ່ມຂໍ້ມູນບໍລິສັດເຂົ້າກ່ອນ'
            }
        },
        deleteIng(ing){
            this.thanphod.ingredients = this.thanphod.ingredients.filter(ingredient => {
                return ingredient != ing
            })
        }
    },
    created(){
        let ref = db.collection('thanphods').where('slug', '==',  this.$route.params.thanphod_slug)
        ref.get().then(snapshot => {
            snapshot.forEach(doc => {
                this.thanphod = doc.data()
                this.thanphod.id = doc.id
            })
        })
    }
}
</script>

<style>
 #fontLao{
     font-family:phetsarath ot;
 }
 .edit-thanphod{
     margin-top: 60;
     padding: 20px;
     max-width: 500px;
 }
 .edit-thanphod h2{
     font-size: 2em;
     margin: 20px auto;
 }
 .edit-thanphod .field{
     margin:  20px auto;
     position: relative;
 }
 .edit-thanphod .delete{
     position:absolute;
     right: 0;
     bottom: 16px;
     color: #aaa;
     font-size: 1.4em;
     cursor: pointer;
 }
</style>
</style>



// WEBPACK FOOTER //
// src/components/EditThanphod.vue